import { Injectable, signal } from '@angular/core';

declare global {
  interface Window {
    AppLoginBridge?: { onLoginSuccess?(email: string): void };
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppLoginBridgeService {
  private readonly lastNotifiedEmail = signal<string | null>(null);

  onLoginSuccess(email: string) {
    if (email !== this.lastNotifiedEmail()) {
      window.AppLoginBridge?.onLoginSuccess?.(email);
      this.lastNotifiedEmail.set(email);
    }
  }

  resetLastNotifiedEmail() {
    this.lastNotifiedEmail.set(null);
  }
}
